import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input, Row, Col, FormFeedback, Card, CardBody } from 'reactstrap';
import { metadataService , userService} from '../../_services'
import { SlButton, SlFormEntryRow, TextInput } from './widgets';
//import { connect } from "react-redux";
import { Alert } from 'reactstrap';
import { registrationActions } from '../../_actions';
//import validator from 'validator';


class MfaCodeEntry extends Component {
    constructor(props) {
        super(props);
        this.updateCodeValue = this.updateCodeValue.bind(this);
        this.checkSubmit = this.checkSubmit.bind(this);
        this.reSendCode = this.reSendCode.bind(this);
    }
    checkSubmit(e){
        e.preventDefault();
        if(this.props.value.length === 2 && 
            this.props.value[0].length >= 2 && 
            this.props.value[1].length >= 2){
            //Can submit. 
            this.props.onSubmit();
        }
    }

    updateCodeValue(e){
        const updatedValue = e.target.value.replace(" ", ""); 
        let newValue = [...this.props.value]; 
        const numLength = updatedValue.length; 
        if(numLength < 3){
          newValue[0] = updatedValue; 
          newValue[1] = '';
        }
        else{ 
          const partLen = Math.floor(numLength / 2); 
          newValue[0] = updatedValue.slice(0, partLen); 
          newValue[1] = updatedValue.slice(partLen, numLength)  
        }
        this.props.valueUpdated(newValue)
    }
    reSendCode(){
      if(this.props.onReSend){
        this.props.onReSend();
      }
    }
    render() {
        return (
            <div className="SignUpEmailValidation">
            <Card>
              <CardBody>
                <SlFormEntryRow>
                 <p>{this.props.mfaSentMessage}</p>
                </SlFormEntryRow>
                <SlFormEntryRow>
                <p>{metadataService.getMessage('MfaEnterConfirmInfo')}</p>
                </SlFormEntryRow>
                <Row className="justify-content-center">
                <Col xs={12} md={6}>
                  <FormGroup>
                    <Label for="validationCode1" hidden>
                      {metadataService.getLabel('ConfirmationCode')}
                    </Label>
                    <Row>
                      <Col  xs={{size: 6, offset:3}} md={{size: 6, offset:3}} >
                        <Input
                          type="tel"
                          name="validationCode1"
                          id="validationCode1"
                          placeholder=""
                          maxLength='10'
                          style={{textAlign:'center'}}
                          value={this.props.value[0] + this.props.value[1]}
                          onChange={e => this.updateCodeValue(e)}
                        />
                      </Col>
                    </Row>
                      {this.props.error && (<FormFeedback invalid style={{display:'block', textAlign:'center'}}>{this.props.error}</FormFeedback>)}
                      </FormGroup>
                    </Col>
                </Row>
                    
              </CardBody>
            </Card>           
            <Row className="justify-content-center">
              <Col xs={12} md={6}>
                <div className="text-center">
                    <SlButton name='ConfirmCode' disabled={this.props.disabled} onClick={this.checkSubmit}/>
                </div>
              </Col>
            </Row>
            <Row className="justify-content-center p-3">
              <Col xs={12} md={6}>
                <div className="text-center">
                    <p>{metadataService.getMessage("DidntGetCode")}{" "}<a className='sl-link' disabled={this.props.disabled} onClick={this.reSendCode}>{metadataService.getLabel("SendAgain")}</a></p>
                </div>
              </Col>
            </Row>

          </div>
        );
    }
}

//Define prop types
MfaCodeEntry.propTypes = {
    message: PropTypes.string.isRequired,
    valueUpdated: PropTypes.func.isRequired,
    value:PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onReSend: PropTypes.func,
    error: PropTypes.string,
    disabled : PropTypes.bool
}
MfaCodeEntry.defaultProps = {
  disabled : false
}

function mapStateToProps(state) {
  const { loggedIn } = state.authentication; 
  return {
      loggedIn
  };
}

 

const connectedMfaCodeEntry = connect(mapStateToProps)(MfaCodeEntry);
export { connectedMfaCodeEntry as MfaCodeEntry };


// WEBPACK FOOTER //
// ./src/components/editors/MfaCodeEntry.jsx